export const removeBackgroundImagesLimit = 50;
export const transparentBackground = "#00000000";
